<template>
    <div class="alert alert-white" :class="classVariant" role="alert">
        <div class="icon text-white">
            <i :class="icone"></i>
        </div>
        <div class="texto-alert text-center" v-html="texto"></div>
    </div>
</template>

<script>
export default {
    props: {
        variant: {
            type: String,
            default: "primary",
        },
        texto: String,
        icone: {
            type: String,
            default: "circle-info",
        },
    },
    computed: {
        classVariant() {
            return `alert-${this.variant}`;
        },
    },
};
</script>

<style>
.alert.alert-white {
    border-radius: 0;
    -webkit-border-radius: 0;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.11);
    display: table;
    width: 100%;
}
.alert-white {
    background-image: linear-gradient(to bottom, #fff, #f9f9f9);
    border-top-color: #d8d8d8;
    border-bottom-color: #bdbdbd;
    border-left-color: #cacaca;
    border-right-color: #cacaca;
    color: #404040;
    padding-left: 61px;
    position: relative;
}
.alert-white.rounded {
    border-radius: 3px;
    -webkit-border-radius: 3px;
}
.alert-white.rounded .icon {
    border-radius: 3px 0 0 3px;
    -webkit-border-radius: 3px 0 0 3px;
}
.alert-white .icon {
    text-align: center;
    width: 45px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #bdbdbd;
    padding-top: 25px;
}
.alert-white .icon:after {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
    display: block;
    content: "";
    width: 10px;
    height: 10px;
    border: 1px solid #bdbdbd;
    position: absolute;
    border-left: 0;
    border-bottom: 0;
    top: 50%;
    right: -6px;
    margin-top: -3px;
    background: #fff;
}
.alert-white .icon svg {
    font-size: 20px;
    color: #fff;
    left: 12px;
    margin-top: -10px;
    position: absolute;
    top: 50%;
}
.alert-white.alert-success {
    color: #3c763d;
    background-color: #fff;
    border-color: #3c763d;
}
.alert-white.alert-success .icon,
.alert-white.alert-success .icon:after {
    border-color: #3cd458;
    background: #3cd458;
}
.alert-white.alert-info {
    background-color: #fff;
    border-color: #926dde;
    color: #926dde;
}
.alert-white.alert-info .icon,
.alert-white.alert-info .icon:after {
    border-color: #926dde;
    background: #926dde;
}
.alert-white.alert-warning .icon,
.alert-white.alert-warning .icon:after {
    border-color: #ffba00;
    background: #ffba00;
}
.alert-white.alert-warning {
    background-color: #fff;
    border-color: #ffba00;
    color: #ffba00;
}
.alert-white.alert-danger {
    background-color: #fff;
    border-color: #ff4954;
    color: #ff4954;
}
.alert-white.alert-danger .icon,
.alert-white.alert-danger .icon:after {
    border-color: #ff4954;
    background: #ff4954;
}
</style>
